import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Endpoints, setAuthToken, clearAuthToken, getAuthToken } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    if (!token) {
      setChecking(false);
      return;
    }
    Endpoints.me()
      .then((u) => setUser(u))
      .catch(() => {
        clearAuthToken();
        setUser(null);
      })
      .finally(() => setChecking(false));
  }, []);

  useEffect(() => {
    const onLogout = () => {
      clearAuthToken();
      setUser(null);
    };
    window.addEventListener("auth:logout", onLogout);
    return () => window.removeEventListener("auth:logout", onLogout);
  }, []);

  const login = useCallback(async (email, password) => {
    const data = await Endpoints.login(email, password);
    setAuthToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await Endpoints.logout();
    } catch (_) {
      /* token may already be gone — clear locally regardless */
    }
    clearAuthToken();
    setUser(null);
  }, []);

  return (
    <AuthCtx.Provider value={{ user, checking, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}
